import {
    Campfire,
    ChatCircle,
    ChatsCircle,
    Clock,
    Diamond,
    Fire,
    Globe,
    Heart,
    HeartStraight,
    Lightning,
    MagicWand,
    Medal,
    Megaphone,
    Newspaper,
    Palette,
    PencilSimple,
    Planet,
    ShieldCheck,
    Smiley,
    Sparkle,
    Trophy,
    UserPlus,
    UsersThree,
} from '@phosphor-icons/react';

/**
 * Запасное оформление достижений.
 *
 * Основной вид значка — картинка, её отдаёт сервер полем `image`. Этот файл
 * нужен для достижений, которым картинку ещё не нарисовали: тогда рисуется
 * иконка с цветной подложкой. Выбором между ними занимается `AchievementBadge`.
 *
 * Цвет группы общий, форма иконки — своя на каждый порог: так тиры одной
 * метрики читаются как один набор. Коды те же, что в каталоге на сервере
 * (`server/config/achievements.js`), цвета — те же, что в приложении.
 */
const APPEARANCE = {
    posts_5: { icon: PencilSimple, color: '#0a84ff' },
    posts_25: { icon: Newspaper, color: '#0a84ff' },
    posts_50: { icon: Megaphone, color: '#0a84ff' },

    comments_5: { icon: ChatCircle, color: '#30d158' },
    comments_25: { icon: ChatsCircle, color: '#30d158' },
    comments_50: { icon: UsersThree, color: '#30d158' },

    likes_given_5: { icon: Heart, color: '#ff375f' },
    likes_given_25: { icon: HeartStraight, color: '#ff375f' },
    likes_given_50: { icon: Fire, color: '#ff375f' },

    likes_received_5: { icon: Sparkle, color: '#ff9f0a' },
    likes_received_25: { icon: Medal, color: '#ff9f0a' },
    likes_received_50: { icon: Trophy, color: '#ff9f0a' },

    founder: { icon: Diamond, color: '#af52de' },
    my_wife: { icon: Diamond, color: '#af52de' },

    streak_7: { icon: Lightning, color: '#ff9f0a' },
    streak_14: { icon: Campfire, color: '#ff9f0a' },
    streak_30: { icon: Planet, color: '#ff9f0a' },

    veteran_365: { icon: Clock, color: '#64d2ff' },
    veteran_730: { icon: ShieldCheck, color: '#64d2ff' },

    interlocutors_3: { icon: UserPlus, color: '#30d158' },
    interlocutors_5: { icon: UsersThree, color: '#30d158' },
    interlocutors_10: { icon: Globe, color: '#30d158' },

    reactions_50: { icon: Smiley, color: '#ff375f' },
    reactions_100: { icon: MagicWand, color: '#ff375f' },
    reactions_250: { icon: Palette, color: '#ff375f' },
};

const FALLBACK = { icon: Trophy, color: '#ff9f0a' };

/** Сколько достижений можно вынести в профиль (то же число в сервисе на сервере). */
export const MAX_SHOWCASED_ACHIEVEMENTS = 5;

export function achievementAppearance(code) {
    return APPEARANCE[code] ?? FALLBACK;
}
